























































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BoxList from '@/BoxList.vue';
import BoxDimensionSelect from '@/BoxDimensionSelect.vue'
import { Project } from '../../../common/project';
import gql from 'graphql-tag';

import * as PLANTS_QUERY               from 'src/graphql/Plants.graphql';
import * as UPDATE_PLANT_QUERY         from 'src/graphql/ProjectUpdatePlant.graphql';
import * as WRITE_FRAGMENT_PLANT_QUERY from 'src/graphql/ProjectPlantFragment.graphql';

import * as FOOD_TYPES_QUERY               from 'src/graphql/FoodTypes.graphql';
import * as UPDATE_FOOD_TYPE_QUERY         from 'src/graphql/ProjectUpdateFoodType.graphql';
import * as WRITE_FRAGMENT_FOOD_TYPE_QUERY from 'src/graphql/ProjectFoodTypeFragment.graphql';

import * as PACKAGING_SYSTEMS_QUERY               from 'src/graphql/PackagingSystems.graphql';
import * as UPDATE_PACKAGING_SYSTEM_QUERY         from 'src/graphql/ProjectUpdatePackagingSystem.graphql';
import * as WRITE_FRAGMENT_PACKAGING_SYSTEM_QUERY from 'src/graphql/ProjectPackagingSystemFragment.graphql';

import * as STORAGE_CONDITIONS_QUERY               from 'src/graphql/StorageConditions.graphql';
import * as UPDATE_STORAGE_CONDITION_QUERY         from 'src/graphql/ProjectUpdateStorageCondition.graphql';
import * as WRITE_FRAGMENT_STORAGE_CONDITION_QUERY from 'src/graphql/ProjectStorageConditionFragment.graphql';


@Component({
  components: {
    BoxList,
    BoxDimensionSelect
  },
  apollo: {
    plants_for_group: {
      query: PLANTS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
    food_types: {
      query: FOOD_TYPES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
    packaging_systems: {
      query: PACKAGING_SYSTEMS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
    storage_conditions: {
      query: STORAGE_CONDITIONS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class BoxDetailsCards extends Vue {
  @Prop() editable : boolean;
  mouseOver = false;

  selectedPlant = null;
  plants_for_group = [];

  selectedFoodType = null;
  food_types = [];

  selectedPackagingSystem = null;
  packaging_systems = [];

  selectedStorageCondition = null;
  storage_conditions = [];


  get project() {
    return this.$store.state.currentProject
  }

  get box() {
    return this.project && this.project.box;
  }

  setCategory(projectAttribute: string, selectedAttribute: string, listAttribute: string) {
    let item = this.project[projectAttribute];
    if (this.project[projectAttribute] != null) {
      let foundValue = this[listAttribute].find( dbValue => dbValue.id == item.id );

      if (foundValue) {
        this[selectedAttribute] = foundValue;
        item.placeholder = null;
      } else {
        if (item.deleted) {
          item.placeholder = `${item.name} (deleted)`;
        } else if (item.newest) {
          item.placeholder = `${item.name} (outdated)`;
        } else if (!this.$apollo.queries[listAttribute].loading) {
          item.placeholder = `${item.name} (access denied)`;
        }

        this[selectedAttribute] = item;
      }
    }
  }

  @Watch('project')
  onProjectChanged() {
    this.setCategory('plant',             'selectedPlant',            'plants_for_group');
    this.setCategory('food_type',         'selectedFoodType',         'food_types');
    this.setCategory('packaging_system',  'selectedPackagingSystem',  'packaging_systems');
    this.setCategory('storage_condition', 'selectedStorageCondition', 'storage_conditions');
  }

  @Watch('plants_for_group')
  onPlantsLoaded() {
    this.setCategory('plant', 'selectedPlant', 'plants_for_group');
  }

  @Watch('food_types')
  onFoodTypesLoaded() {
    this.setCategory('food_type', 'selectedFoodType', 'food_types');
  }

  @Watch('packaging_systems')
  onPackagingSystemsLoaded() {
    this.setCategory('packaging_system',  'selectedPackagingSystem',  'packaging_systems');
  }

  @Watch('storage_conditions')
  onStorageConditionsLoaded() {
    this.setCategory('storage_condition', 'selectedStorageCondition', 'storage_conditions');
  }

  updateCategory(item, idAttribute: string, projectAttribute: string, type: string, updateQuery: string, writeQuery: string)
  {
    let variables = { id: this.project.id };
    variables[idAttribute] = item.id;

    let optimisticResponse = { __typename: 'Mutation' };
    optimisticResponse['projectUpdate' + type] = {
      __typename: type,
      ...item,
    };

    if (item != null && (this.project[projectAttribute] == null || this.project[projectAttribute].id != item.id)) {
      this.$apollo.mutate({
        mutation: updateQuery,
        variables,
        update: (store, { data: updateData }) => {
          let data = { __typename: 'Project' };
          data[projectAttribute] = updateData['projectUpdate' + type];

          store.writeFragment({
            id: `Project:${this.project.id}`,
            fragment: writeQuery,
            fragmentName: 'Project' + type,
            data,
          });
        },
        optimisticResponse,
      });
    }
  }

  @Watch('selectedPlant')
  onPlantChanged() {
    this.updateCategory(
      this.selectedPlant,
      'plantId',
      'plant',
      'Plant',
      UPDATE_PLANT_QUERY,
      WRITE_FRAGMENT_PLANT_QUERY
    );
  }

  @Watch('selectedFoodType')
  onFoodTypeChanged() {
    this.updateCategory(
      this.selectedFoodType,
      'foodTypeId',
      'food_type',
      'FoodType',
      UPDATE_FOOD_TYPE_QUERY,
      WRITE_FRAGMENT_FOOD_TYPE_QUERY
    );
  }

  @Watch('selectedPackagingSystem')
  onPackagingSystemChanged() {
    this.updateCategory(
      this.selectedPackagingSystem,
      'packagingSystemId',
      'packaging_system',
      'PackagingSystem',
      UPDATE_PACKAGING_SYSTEM_QUERY,
      WRITE_FRAGMENT_PACKAGING_SYSTEM_QUERY
    );
  }

  @Watch('selectedStorageCondition')
  onStorageConditionChanged() {
    this.updateCategory(
      this.selectedStorageCondition,
      'storageConditionId',
      'storage_condition',
      'StorageCondition',
      UPDATE_STORAGE_CONDITION_QUERY,
      WRITE_FRAGMENT_STORAGE_CONDITION_QUERY
    );
  }

  onCarbonFootprintCheckboxChange() {
    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $enable: Boolean!) {
        projectSetSimulateCarbonFootprint(id: $id, enable: $enable)
      }`,
      variables: {
        id: this.project.id,
        enable: !this.project.simulate_carbon_footprint,
      },
      update: (store, {data: { projectSetSimulateCarbonFootprint }}) => {
        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: gql`fragment ProjectSimulateCarbonFootprint on Project {
            simulate_carbon_footprint
          }`,
          data: {
            __typename: 'Project',
            simulate_carbon_footprint: projectSetSimulateCarbonFootprint,
          }
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectSetSimulateCarbonFootprint: !this.project.simulate_carbon_footprint,
      },
    });
  }

  onFoodSafetyCheckboxChange() {
    this.$apollo.mutate({
      mutation: gql`mutation ($id: Int!, $enable: Boolean!) {
        projectSetSimulateFoodSafety(id: $id, enable: $enable)
      }`,
      variables: {
        id: this.project.id,
        enable: !this.project.simulate_food_safety,
      },
      update: (store, {data: { projectSetSimulateFoodSafety }}) => {
        store.writeFragment({
          id: `Project:${this.project.id}`,
          fragment: gql`fragment ProjectSimulateFoodSafety on Project {
            simulate_food_safety
          }`,
          data: {
            __typename: 'Project',
            simulate_food_safety: projectSetSimulateFoodSafety,
          }
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectSetSimulateFoodSafety: !this.project.simulate_food_safety,
      },
    });
  }

  placeholder(item) {
    if (item && item.placeholder)
      return item.placeholder;

    return '';
  }

  appendIcon(item) {
    if (item && item.newest)
      return 'update';

    return '';
  }

  appendIconCallbackPlant(item) {
    if (!item || !item.newest)
      return;

    this.updateCategory(
      item.newest,
      'plantId',
      'plant',
      'Plant',
      UPDATE_PLANT_QUERY,
      WRITE_FRAGMENT_PLANT_QUERY
    );
  }

  appendIconCallbackFoodType(item) {
    if (!item || !item.newest)
      return;

    this.updateCategory(
      item.newest,
      'foodTypeId',
      'food_type',
      'FoodType',
      UPDATE_FOOD_TYPE_QUERY,
      WRITE_FRAGMENT_FOOD_TYPE_QUERY
    );
  }

  appendIconCallbackPackagingSystem(item) {
    if (!item || !item.newest)
      return;

    this.updateCategory(
      item.newest,
      'packagingSystemId',
      'packaging_system',
      'PackagingSystem',
      UPDATE_PACKAGING_SYSTEM_QUERY,
      WRITE_FRAGMENT_PACKAGING_SYSTEM_QUERY
    );
  }

  appendIconCallbackStorageCondition(item) {
    if (!item || !item.newest)
      return;

    this.updateCategory(
      item.newest,
      'storageConditionId',
      'storage_condition',
      'StorageCondition',
      UPDATE_STORAGE_CONDITION_QUERY,
      WRITE_FRAGMENT_STORAGE_CONDITION_QUERY
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxDetailsCard.vue